import React, {useState, useEffect } from "react";
import {
  Button,
  Card,
  CardText,
  CardTitle,
  Grid,
  TableColumn,
  SelectField,
  Cell,
  TextField,
} from "react-md";
import { Tabs, Tab } from 'react-md';
import { confirmAlert } from 'react-confirm-alert'; // Import
import { CSVLink } from "react-csv";
import "../../css/mediaCss.css";
import Toggle from "react-toggle";
import { colorsArray, getColorsArrayDisPlayOrder, AngleDisplayOptions } from "./commonHelpers";
import trashIcon from '../../images/png/trashIcon.png';
import deleteIcon from '../../images/png/deleteIcon.png';
import rigtArrowIcon from '../../images/png/right-arrow.png';
import leftArrowIcon from '../../images/png/left-arrow.png';
import plus from '../../images/png/plus.png';
import { DEFAULT_VECTOR_SNAP_TO_GIRD, DEFAULT_ZERO_POINT_COLOR, DEFAULT_ZERO_POINT_RADIUS, SymbolType } from "../../pages/AssignmentMatrix/Constants";
import { IoAddCircle } from "react-icons/io5";
import { IconButton, Tooltip, Avatar, Chip } from "@mui/material";
import LabelPositionFields from "./LabelPositionFields";
import ZeroAndSymbolVectorFields from "./ZeroAndSymbolVectorFields";
import SFVectorConfiguration from "./SFVectorConfiguration";
import SFVectorConfigurationCompact from "./SFVectorConfigurationCompact";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { PiCaretDown } from "react-icons/pi";

const ITEMS_PER_PAGE = 5;

const VectorVariableOption = (props) => {
  const { classNameString, data,onAddVectorAnswer,onRemoveVectorAnswer } = props;
  const [activeVectorIndex, setActiveVectorIndex] = useState(
  props.activeVectorIndex ?? (data?.length ? data.length - 1 : 0)
); // Currently selected vector
  const [currentPage, setCurrentPage] = useState(0); // For paginating the vector icons
  const totalPages = Math.ceil(data?.length / ITEMS_PER_PAGE);
  const [errorZeroVectorRadius, setErrorZeroVectorRadius] = useState(false);
  
  let isSnapToGrid = DEFAULT_VECTOR_SNAP_TO_GIRD;
  if (props.vectorSettingsData) {
    isSnapToGrid = !props.vectorSettingsData.isSnapToGridOff
  }

  useEffect(() => {
    if (data && data.length && activeVectorIndex) {
      onChange(data[activeVectorIndex]);
    }
  }, [])

  // Get the icons for the current page
  const displayedIcons = data?.slice(
    currentPage * ITEMS_PER_PAGE,
    (currentPage + 1) * ITEMS_PER_PAGE
  );

  const onVectorDeleteConfirm =(i) =>   {
    confirmAlert({
      title: 'Do you really want to delete this vector ?',
      message: 'Press Confirm to submit',

      cancelLabel: 'Confirm',
      confirmLabel: 'Cancel',
      onCancel: () => onRemoveVectorAnswer(i)
    });
}
  const isAnglevalid =(variableObj) =>   {
      return variableObj.inputType === "angle-magnitude" && (variableObj.variableType === "INT" || variableObj.variableType === "FLOAT" );
  }
  const isCompValid =  (variableObj) =>   {
    return variableObj.inputType === "components" && (variableObj.variableType === "RANGE" || variableObj.variableType === "RANGE CONTINUOUS" || variableObj.variableType === "LIST" );
}

const onChange = (value) => {
  props.onTableRowChange(value, activeVectorIndex);
}

  if (!data) return null;

  return (
    <Card className={classNameString} style={{ marginLeft: "0px" }}>
        <Accordion>
          <AccordionSummary
            expandIcon={<PiCaretDown fontSize={24} />}
          >
            <div>
              <div style={{ fontSize: '24px' }}>
                Vectors Configuration {props.index !== null && props.index !== undefined ? `for Answer ${props.index+1}` : ""}
              </div>
              <div style={{ fontSize: '14px', color: 'gray' }}>Edit variables used in the Answer</div>
            </div>
          </AccordionSummary>
      <div style={{display:"flex"}}>

      {/* Vector Icons with Pagination */}
      <div style={{ display: 'flex', justifyContent: 'center', alignItems:'center', marginBottom: '20px',marginTop: "20px",
         marginLeft: "25px" }}>
        {
          currentPage !== 0 ?

          <Button
            style={{display:'flex', justifyContent:'center', alignItems:'center'}}
            disabled={currentPage === 0}
            onClick={() => setCurrentPage((prev) => prev - 1)}
          >
            <img  src={leftArrowIcon} style={{padding:'4px'}} alt="Prev" />
          </Button> : ""
        }

        {displayedIcons?.map((variableObj, i) => {
          const globalIndex = currentPage * ITEMS_PER_PAGE + i;
          console.debug("globalIndex>>??", variableObj, globalIndex);
          let isActive = activeVectorIndex === globalIndex;
          return (
              <div key={globalIndex} style={{ position: 'relative', display: 'inline-block', marginRight:'8px' }}>
                <Chip
                  size="medium"
                  label={variableObj.name}
                  variant={isActive ? 'filled' : 'outlined'}
                  onClick={() => setActiveVectorIndex(globalIndex)}
                  onDelete={data?.length > 1 ? () => onVectorDeleteConfirm(i) : undefined}
                  sx={{
                    fontSize: 14,
                    bgcolor: isActive ? '#bb0000' : undefined,
                    color: isActive ? '#fff' : undefined,
                    '&:hover': {
                      bgcolor: isActive ? '#bb0000' : undefined,
                    },
                    '& .MuiChip-deleteIcon': {
                      color: isActive ? '#fff' : undefined,
                      '&:hover': {
                        color: isActive ? '#fff' : undefined,
                      },
                    },
                  }}
                />
                
              </div>
              
          );
        })}
       {
          currentPage !== totalPages - 1 ?

          <Button
          style={{display:'flex', justifyContent:'center', alignItems:'center'}}
          disabled={currentPage === totalPages - 1}
          onClick={() => setCurrentPage((prev) => prev + 1)}
        >
           <img src={rigtArrowIcon} style={{padding:'4px'}} alt="Next" />
          
        </Button>: ""
        }
      
         <Tooltip title="Add Vector" arrow placement="bottom">
          <IconButton onClick={onAddVectorAnswer}>
            <IoAddCircle color="#bb0000" size={22} />
          </IconButton>
        </Tooltip>

      </div>
      </div>
      {data?.length > 0 && (
        <div>
          <CardText  style={{display:"flex",overflow:"scroll"}}>
          {data?.length > 0 &&
          
          <div style={{width:'100%', }}>
            <SFVectorConfigurationCompact 
                index={activeVectorIndex}
                isSnapToGrid={isSnapToGrid}
                variableObj={{
                  ...data[activeVectorIndex],
                  isStandaloneVector: true,
                }}
                onTableRowChange={(newData) => {
                  onChange(newData)
                }}
            />
                {/* <Grid key={activeVectorIndex} style={{ minWidth: "500px" }}>

                  <Cell size={3}>
                    <TextField
                      className="textFieldClass heightLight"
                      // disabled
                      onChange={val => {
                        data[activeVectorIndex].name = val;
                        onChange(data[activeVectorIndex]);
                      }}
                      value={data[activeVectorIndex].name}
                      label={"Vector-" + (activeVectorIndex + 1)}
                      id={`text-field-${activeVectorIndex}`}
                    />
                  </Cell>
                  <Cell size={3}>
                    <SelectField
                      id={`text-color-${activeVectorIndex}`}
                      label="Color"
                      fullWidth
                      onChange={(value) => {
                        data[activeVectorIndex].color = value;
                        onChange(data[activeVectorIndex]);
                      }}
                      menuItems={colorsArray}
                      value={data[activeVectorIndex].color}
                    />
                  </Cell>
                  <Cell size={3}>
                    <SelectField
                      id={`variable-type-${activeVectorIndex}`}
                      label="Type"
                      fullWidth
                      onChange={(value) => {
                        data[activeVectorIndex].inputType = value;
                        if (value === "components") {
                          data[activeVectorIndex].variableType = "RANGE";
                        } else {
                          data[activeVectorIndex].variableType = "INT";
                        }

                        onChange(data[activeVectorIndex]);
                      }}
                      menuItems={["components", "angle-magnitude"]}
                      value={data[activeVectorIndex].inputType}
                    />
                  </Cell>
                  <Cell size={3}>
                    {data[activeVectorIndex].inputType === "components" ? (
                      <SelectField
                        id={`variable-type1-${activeVectorIndex}`}
                        label="Type"
                        onChange={(value) => {
                          if (value === "RANGE INTEGER") {
                            value = "RANGE"
                          }
                          data[activeVectorIndex].variableType = value;
                          onChange(data[activeVectorIndex]);
                        }}
                        menuItems={isSnapToGrid ? ["RANGE INTEGER", "LIST"] : ["RANGE INTEGER", "RANGE CONTINUOUS", "LIST"]}
                        value={data[activeVectorIndex].variableType === "RANGE" ? "RANGE INTEGER" : data[activeVectorIndex].variableType}
                      />
                    ) : (
                      <SelectField
                        helpText="Select a vector variable type"
                        id={`variable-type1-${activeVectorIndex}`}
                        label="Type"
                        onChange={(value) => {
                          data[activeVectorIndex].variableType = value;
                          onChange(data[activeVectorIndex]);
                        }}
                        style={{ width: "109px" }}
                        menuItems={["INT", "FLOAT"]}
                        value={data[activeVectorIndex].variableType}
                      />
                    )}
                    {data?.length > 1 ?

                      <Button icon tooltipLabel="Delete"
                        style={{ marginLeft: "10px", marginBottom: "20px" }}
                        onClick={() => onVectorDeleteConfirm(activeVectorIndex)}>
                        <img src={trashIcon} alt="Delete" />
                      </Button> : ""
                    }

                  </Cell>

                  {(isCompValid || isAnglevalid) && <GetRow1 variableObj={data[activeVectorIndex]} i={activeVectorIndex} props={props} onChange={onChange} />}
                  {(isCompValid || isAnglevalid) && <GetRow2 variableObj={data[activeVectorIndex]} i={activeVectorIndex} props={props} onChange={onChange} />}

                  <ZeroAndSymbolVectorFields
                    index={activeVectorIndex}
                    latexSymbol={data[activeVectorIndex].latexSymbol ? data[activeVectorIndex].latexSymbol : 0}
                    onLatexSymbolChange={(newValue) => {
                      data[activeVectorIndex].latexSymbol = newValue;
                      onChange(data[activeVectorIndex]);
                    }}

                    latexSymbolSize={data[activeVectorIndex].latexSymbolSize}
                    onLatexSymbolSizeChange={(newValue) => {
                      data[activeVectorIndex].latexSymbolSize = newValue;
                      console.debug("data[activeVectorIndex]>>??", data[activeVectorIndex])
                      onChange(data[activeVectorIndex]);
                    }}

                    zeroVectorPointRadius={data[activeVectorIndex].zeroVectorPointRadius}
                    onChangeZeroVectorRadius={(newValue) => {
                      data[activeVectorIndex].zeroVectorPointRadius = newValue;
                      onChange(data[activeVectorIndex]);
                    }}

                    zeroVectorPointColor={data[activeVectorIndex].zeroVectorPointColor}
                    onChangeZeroVectorPointColor={(newValue) => {
                      data[activeVectorIndex].zeroVectorPointColor = newValue;
                      onChange(data[activeVectorIndex]);
                    }}
                  />

                  <Cell size={2}>
                    <label
                      htmlFor={`show-label-check-${activeVectorIndex}`}
                      className="vectors-toggle-label"
                    >
                      {"Show Label"}
                    </label>
                    <Toggle
                      icons={false}
                      width={230}
                      id={`show-label-check-${activeVectorIndex}`}
                      name="Show Label"
                      onChange={(event) => {
                        data[activeVectorIndex].showLabel = event.target.checked;
                        onChange(data[activeVectorIndex]);
                      }}
                      checked={data[activeVectorIndex].showLabel}
                    />
                  </Cell>

                  <LabelPositionFields
                    index={activeVectorIndex}
                    showLabel={data[activeVectorIndex].showLabel}
                    type={data[activeVectorIndex].labelPositionType ? data[activeVectorIndex].labelPositionType : "Automatic"}
                    onTypeChange={(newValue) => {
                      data[activeVectorIndex].labelPositionType = newValue;
                      onChange(data[activeVectorIndex]);
                    }}
                    xValue={data[activeVectorIndex].labelPositionX ? data[activeVectorIndex].labelPositionX : data[activeVectorIndex].posX}
                    onXValueChange={(newValue) => {
                      data[activeVectorIndex].labelPositionX = newValue;
                      onChange(data[activeVectorIndex]);
                    }}
                    yValue={data[activeVectorIndex].labelPositionY ? data[activeVectorIndex].labelPositionY : data[activeVectorIndex].posY}
                    onYValueChange={(newValue) => {
                      data[activeVectorIndex].labelPositionY = newValue;
                      onChange(data[activeVectorIndex]);
                    }}
                  />

                  <Cell size={3}>
                    <label
                      htmlFor={`show-angle-check-${activeVectorIndex}`}
                      className="vectors-toggle-label"
                    >
                      {"Show Angle"}
                    </label>
                    <Toggle
                      icons={false}
                      width={230}
                      id={`show-angle-check-${activeVectorIndex}`}
                      name="Show Angle"
                      onChange={(event) => {
                        data[activeVectorIndex].showAngle = event.target.checked;
                        onChange(data[activeVectorIndex]);
                      }}
                      checked={data[activeVectorIndex].showAngle}
                      className="rp-fraction-checkbox"
                      label="Show Angle"
                    />
                  </Cell>
                  <Cell size={3}>
                    <label
                      htmlFor={`show-components-check-${activeVectorIndex}`}
                      className="vectors-toggle-label"
                    >
                      {"Component"}
                    </label>
                    <Toggle
                      icons={false}
                      width={230}
                      id={`show-components-check-${activeVectorIndex}`}
                      name="Show Components"
                      onChange={(event) => {
                        data[activeVectorIndex].showComponents = event.target.checked;
                        onChange(data[activeVectorIndex]);
                      }}
                      checked={data[activeVectorIndex].showComponents}
                      className="rp-fraction-checkbox"
                      label="Show Components"
                    />
                  </Cell>
                  <Cell size={3}>
                    <label
                      htmlFor={`auto-origin-check-${activeVectorIndex}`}
                      className="vectors-toggle-label"
                    >
                      {"Center Origin"}
                    </label>
                    <Toggle
                      icons={false}
                      width={230}
                      id={`auto-origin-check-${activeVectorIndex}`}
                      name="Auto Origin"
                      onChange={(event) => {
                        data[activeVectorIndex].autoOrigin = event.target.checked;
                        onChange(data[activeVectorIndex]);
                      }}
                      checked={data[activeVectorIndex].autoOrigin}
                      className="rp-fraction-checkbox"
                      label="Auto Origin"
                    />
                  </Cell>
                  <Cell size={3}>
                    <label
                      htmlFor={`show-view-vectors-check-${activeVectorIndex}`}
                      className="vectors-toggle-label"
                    >
                      {"Show in Legend"}
                    </label>
                    <Toggle
                      icons={false}
                      width={230}
                      id={`show-view-vectors-check-${activeVectorIndex}`}
                      name="Show in Legend"
                      onChange={(event) => {
                        data[activeVectorIndex].showLegend = event.target.checked;
                        onChange(data[activeVectorIndex]);
                      }}
                      checked={(data[activeVectorIndex].showLegend !== null && data[activeVectorIndex].showLegend !== undefined) ? data[activeVectorIndex].showLegend : true}
                      className="rp-fraction-checkbox"
                      label="Show in Legend"
                    />
                  </Cell>
                  <br />
                  <AngleOptions
                    variableObj={data[activeVectorIndex]}
                    activeVectorIndex={activeVectorIndex}
                    props={props}
                    visible={data[activeVectorIndex].showAngle}
                  />
                </Grid> */}
          </div>
          }
          </CardText> 
        </div>)
      }
        </Accordion>
    </Card>
  );
};

const ListValuesSection = (props) => {
  let variableObj = props.variableObj;
  let field = props.field;

  const csvData = [
    [
      "In column 1 enter the Question [variable] values",
      "In columns 2 through n enter the n correct answer value(s)",
    ],
    ["Australia", "Melbourne", "Sydney", "Perth"],
    ["India", "New Delhi", "Mumbai", "Chennai"],
    ["USA", "Columbus", "New York", "San Francisco"],
  ];
  return (
    <TableColumn>
      <TextField
        id="list-values"
        placeholder={props.placeholder}
        type="text"
        label={props.fieldName}
        value={variableObj[field] || ""}
        helpText={props.helpText}
        onChange={(value) => {
          variableObj[field] = value;
          props.onChange(variableObj);
        }}
      />
    
    </TableColumn>
  );
};

const GetRow1 = ({variableObj, i, props, onChange}) => {

  const [errorXorigin,setErrorXorigin] = useState(false);
  const [xoriginHelperText,setXoriginHelperText] = useState('');
  const [errorXmin,setErrorXmin] = useState(false);
  const [xminHelperText,setXminHelperText] = useState('');
  const [errorXmax,setErrorXmax] = useState(false);
  const [xmaxHelperText,setXmaxHelperText] = useState('');
  const [errorMagmin,setErrorMagmin] = useState(false);
  const [magminHelperText,setMagminHelperText] = useState('');
  const [errorMagmax,setErrorMagmax] = useState(false);
  const [magmaxHelperText,setMagmaxHelperText] = useState('');

const getfirstInput = (type) => {
  return type === "components" ? "vectorBlackListX" : "vectorBlackListMagnitude";
}

const onXoriginChange = () => {
  if(variableObj.posX != ""){
  if(Number(variableObj.posX) < 0 || Number(variableObj.gridWidthUnit) <= Number(variableObj.posX)){
    setErrorXorigin(true);
    setXoriginHelperText(`Vector ${variableObj.name} is going outside the grid.`); 
  }else{
    setErrorXorigin(false);
    setXoriginHelperText('');
  }
 }
 onXmaxChange()
 onXminChange()
}

const onMagminChange = () => {
  if(variableObj.inputType === "angle-magnitude") {
    if(variableObj.magMin != ""){
      if(Number(variableObj.magMax) < Number(variableObj.magMin)) {
        setErrorMagmin(true);
        setMagminHelperText(`mag-min cannot be greater than mag-max`)
      }else{
        setErrorMagmin(false);
        setMagminHelperText('');
      } 
    }           
   }
}

const onMagmaxChange = () => {
  if(variableObj.inputType === "angle-magnitude") {
    if(variableObj.magMax != ""){
      if(Number(variableObj.magMax) < Number(variableObj.magMin)) {
        setErrorMagmax(true);
        setMagmaxHelperText(`mag-max cannot be less than mag-min`)
      }else{
        setErrorMagmax(false);
        setMagmaxHelperText('');
      } 
    }           
   }
}

const onXminChange = () => {
  if(variableObj.inputType === "components" && variableObj.variableType !== 'LIST') {
    if(variableObj.xMin != ""){
      if(Number(variableObj.xMax) < Number(variableObj.xMin)) {
        setErrorXmin(true);
        setXminHelperText(`x-min cannot be greater than x-max`)
      }else if(Number(variableObj.xMin) < -Number(variableObj.posX)){
        setErrorXmin(true);
        setXminHelperText(`Vector ${variableObj.name} is going outside the grid`)
      }
      else{
        setErrorXmin(false);
        setXminHelperText('');
      } 
    }           
   }
}

const onXmaxChange = () => {
  if(variableObj.inputType === "components" && variableObj.variableType !== 'LIST') {
    if(variableObj.xMax != ""){
      if(Number(variableObj.xMax) < Number(variableObj.xMin)) {
        setErrorXmax(true);
        setXmaxHelperText(`x-max cannot be less than x-min`)
      }else if(Number(variableObj.xMax) > Number(variableObj.gridWidthUnit - variableObj.posX)){
        setErrorXmax(true);
        setXmaxHelperText(`Vector ${variableObj.name} is going outside the grid`)
      }
      else{
        setErrorXmax(false);
        setXmaxHelperText('');
      } 
    }           
   }
}

  return (
    <React.Fragment>
        <Grid>
          <Cell size={3}>
              <TextField
                className="textFieldClass"
                error={errorXorigin}
                value={variableObj.posX ? variableObj.posX : ""}
                disabled={variableObj.autoOrigin}
                label="origin-x"
                type="number"
                id={`text-x-${i}`}
                onChange={(value) => {
                  variableObj.posX = value;
                  onChange(variableObj);
                  onXoriginChange();
                }}
              />
            </Cell>
            {variableObj.latexSymbol === SymbolType.IN_PLANE ? 
              variableObj.inputType === "components" ? (
                <>
                {variableObj.variableType === "RANGE" || variableObj.variableType === "RANGE CONTINUOUS" ? (
                  <React.Fragment>
                    <Cell size={3}>
                      <TextField
                        className="textFieldClass"
                        error={errorXmin}
                        value={variableObj.xMin}
                        label="x-min"
                        type="number"
                        id={`text-x-${i}`}
                        onChange={(value) => {
                          variableObj.xMin = value;
                          onChange(variableObj);
                          onXminChange();
                        }}
                        helpText={errorXmin ? xminHelperText:"x-component min"}
                      />
                    </Cell>
                    <Cell size={3}>
                      <TextField
                        className="textFieldClass"
                        error={errorXmax}
                        value={variableObj.xMax}
                        label="x-max"
                        type="number"
                        id={`text-x-${i}`}
                        onChange={(value) => {
                          variableObj.xMax = value;
                          onChange(variableObj);
                          onXmaxChange();
                        }}
                        helpText={errorXmax ? xmaxHelperText:"x-component max "}
                      />
                    </Cell>
                  </React.Fragment>
                ) : <ListValuesSection 
                      variableObj={variableObj}
                      field="xList"
                      fieldName="List for X"
                      placeholder='Enter list values seperated by comma " , " '
                      helpText="Enter values seperated by comma eg: 1,2.5,3,4,5"
                      onTableRowChange={onChange}
                />}
                </>
              ): (
                <>
                <Cell size={3}>
                  <TextField
                    className="textFieldClass"
                    error = {errorMagmin}
                    value={variableObj.magMin}
                    label="mag-min"
                    type="number"
                    id={`mag-min-${i}`}
                    onChange={(value) => {
                      variableObj.magMin = value ? value : 0;
                      onChange(variableObj);
                      onMagminChange();
                    }}
                    helpText={errorMagmin ? magminHelperText:"magnitude of vector "}
                  />
                </Cell>
                <Cell size={3}>
                  <TextField
                    className="textFieldClass"
                    error = {errorMagmax}
                    value={variableObj.magMax}
                    label="mag-max"
                    type="number"
                    id={`mag-max-${i}`}
                    onChange={(value) => {
                      variableObj.magMax = value ? value : 0;
                      onChange(variableObj);
                      onMagmaxChange();
                    }}
                    helpText={errorMagmax ? magmaxHelperText:"magnitude of vector "}
                  />
                </Cell>
                </>
              )
            : null}

            {variableObj.latexSymbol === SymbolType.OUT_ODOT || variableObj.latexSymbol === SymbolType.IN_OTIMES ? 
              <React.Fragment>
                <Cell size={3}>
                      <TextField
                        className="textFieldClass"
                        value={variableObj.zMin}
                        label="z-min"
                        type="number"
                        id={`text-z-${i}`}
                        onChange={(value) => {
                          variableObj.zMin = value;
                          onChange(variableObj);
                          onXminChange();
                        }}
                      />
                    </Cell>
                    <Cell size={3}>
                      <TextField
                        className="textFieldClass"
                        value={variableObj.zMax}
                        label="z-max"
                        type="number"
                        id={`text-z-${i}`}
                        onChange={(value) => {
                          variableObj.zMax = value;
                          onChange(variableObj);
                          onXmaxChange();
                        }}
                      />
                    </Cell>
              </React.Fragment>
            : null }

            {variableObj.latexSymbol === SymbolType.IN_PLANE ? 
            (variableObj.variableType === "RANGE" || variableObj.variableType === "RANGE CONTINUOUS") || (variableObj.inputType === "angle-magnitude") ? (
                <React.Fragment>
                  <Cell size={3}>
                    <TextField
                      id="text-black-list-x"
                      label={`Excluded List for ${variableObj.inputType === "components" ? "X" : "magnitide"}`}
                      placeholder="Multiple values must be comma separated"
                      type="text"
                      helpText="comma separated"
                      onChange={(value) => {
                        variableObj[getfirstInput(variableObj.inputType)] = value;
                        onChange(variableObj);
                      }}
                      value={variableObj[getfirstInput(variableObj.inputType)] || ""}
                    />
                  </Cell>
                </React.Fragment>
              ) : null
              : null}

        </Grid>
      </React.Fragment>
  )
};

const GetRow2 = ({variableObj, i, props, onChange}) => {
  
  const [errorYorigin,setErrorYorigin] = useState(false);
  const [yoriginHelperText,setYoriginHelperText] = useState('');
  const [errorYmin,setErrorYmin] = useState(false);
  const [yminHelperText,setYminHelperText] = useState('');
  const [errorYmax,setErrorYmax] = useState(false);
  const [ymaxHelperText,setYmaxHelperText] = useState('');
  const [errorAngmin,setErrorAngmin] = useState(false);
  const [angminHelperText,setAngminHelperText] = useState('');
  const [errorAngmax,setErrorAngmax] = useState(false);
  const [angmaxHelperText,setAngmaxHelperText] = useState('');

  const getsecondInput = (type) => {
    return type === "components" ? "vectorBlackListY" : "vectorBlackListAngle";
  } 

  const onYoriginChange = () => {
    if(variableObj.posY != ""){
    if(Number(variableObj.posY) < 0 || Number(variableObj.gridHeightUnit) <= Number(variableObj.posY)){
      setErrorYorigin(true);
      setYoriginHelperText(`Vector ${variableObj.name} is going outside the grid.`); 
    }else{
      setErrorYorigin(false);
      setYoriginHelperText('');
    }
   }
    onYmaxChange()
    onYminChange()
  }

  const onAngminChange = () => {
    if(variableObj.inputType === "angle-magnitude") {
      if(variableObj.angleMin != ""){
        if(Number(variableObj.angleMax) < Number(variableObj.angleMin)) {
          setErrorAngmin(true);
          setAngminHelperText(`angle-min cannot be greater than angle-max`)
        }else{
          setErrorAngmin(false);
          setAngminHelperText('');
        } 
      }           
     }
  }
  
  const onAngmaxChange = () => {
    if(variableObj.inputType === "angle-magnitude") {
      if(variableObj.angleMax != ""){
        if(Number(variableObj.angleMax) < Number(variableObj.angleMin)) {
          setErrorAngmax(true);
          setAngmaxHelperText(`angle-max cannot be less than angle-min`)
        }else{
          setErrorAngmax(false);
          setAngmaxHelperText('');
        } 
      }           
     }
  }

  const onYminChange = () => {
    if(variableObj.inputType === "components" && variableObj.variableType !== 'LIST') {
      if(variableObj.yMin != ""){
        if(Number(variableObj.yMax) < Number(variableObj.yMin)) {
          setErrorYmin(true);
          setYminHelperText(`y-min cannot be greater than y-max`)
        }else if(Number(variableObj.yMin) < -Number(variableObj.posY)){
          setErrorYmin(true);
          setYminHelperText(`Vector ${variableObj.name} is going outside the grid`)
        }
        else{
          setErrorYmin(false);
          setYminHelperText('');
        } 
      }           
     }
  }
  
  const onYmaxChange = () => {
    if(variableObj.inputType === "components" && variableObj.variableType !== 'LIST') {
      if(variableObj.yMax != ""){
        if(Number(variableObj.yMax) < Number(variableObj.yMin)) {
          setErrorYmax(true);
          setYmaxHelperText(`y-max cannot be less than y-min`)
        }else if(Number(variableObj.yMax) > Number(variableObj.gridHeightUnit - variableObj.posY)){
          setErrorYmax(true);
          setYmaxHelperText(`Vector ${variableObj.name} is going outside the grid`)
        }
        else{
          setErrorYmax(false);
          setYmaxHelperText('');
        } 
      }           
     }
  }
 
  return (
    <React.Fragment>
        <Grid>
          
            <Cell size={3}>
              <TextField
                className="textFieldClass"
                error ={errorYorigin}
                disabled={variableObj.autoOrigin}
                value={variableObj.posY ? variableObj.posY : ""}
                label="origin-y"
                type="number"
                id={`text-y-${i}`}
                onChange={(value) => {
                  variableObj.posY = value;
                  onChange(variableObj);
                  onYoriginChange();
                }}
              />
            </Cell>
            {variableObj.latexSymbol === SymbolType.IN_PLANE ? 
            variableObj.inputType === "components" ? (
              <>
              {variableObj.variableType === "RANGE" || variableObj.variableType === "RANGE CONTINUOUS" ? (
                  <React.Fragment>
                  <Cell size={3}>
                    <TextField
                      className="textFieldClass"
                      error={errorYmin}
                      value={variableObj.yMin}
                      label="y-min"
                      type="number"
                      id={`text-y-${i}`}
                      onChange={(value) => {
                        variableObj.yMin = value;
                        onChange(variableObj);
                        onYminChange();
                      }}
                      helpText={errorYmin ? yminHelperText:"y-component min "}
                    />
                  </Cell>
                  <Cell size={3}>
                    <TextField
                      className="textFieldClass"
                      error={errorYmax}
                      value={variableObj.yMax}
                      label="y-max"
                      type="number"
                      id={`text-y-${i}`}
                      onChange={(value) => {
                        variableObj.yMax = value;
                        onChange(variableObj);
                        onYmaxChange();
                      }}
                      helpText={errorYmax ? ymaxHelperText:"y-component max"}
                    />
                  </Cell>
                  </React.Fragment>
                ) : <ListValuesSection 
                        variableObj={variableObj}
                        field="yList"
                        fieldName="List for Y"
                        placeholder='Enter list values seperated by comma " , " '
                        helpText="Enter values seperated by comma eg: 1,2.5,3,4,5"
                        onTableRowChange={onChange}
                  />}
              </>) : (<>
                <Cell size={3}>
                  <TextField
                    className="textFieldClass"
                    error={errorAngmin}
                    value={variableObj.angleMin}
                    label="angle-min"
                    type="number"
                    id={`angle-min-${i}`}
                    onChange={(value) => {
                      variableObj.angleMin = value ? value : 0;
                      onChange(variableObj);
                      onAngminChange();
                    }}
                    helpText={errorAngmin ? angminHelperText:"angle component of vector"}
                  />
                </Cell>
                <Cell size={3}>
                  <TextField
                    className="textFieldClass"
                    error={errorAngmax}
                    value={variableObj.angleMax}
                    label="angle-max"
                    type="number"
                    id={`angle-max-${i}`}
                    onChange={(value) => {
                      variableObj.angleMax =  value ? value : 0;
                      onChange(variableObj);
                      onAngmaxChange();
                    }}
                    helpText={errorAngmax ? angmaxHelperText:"angle component of vector"}
                  />
                </Cell>
              </>
            )
            : null}

          {variableObj.latexSymbol === SymbolType.IN_PLANE ? 
          (variableObj.variableType ===  "RANGE" || variableObj.variableType === "RANGE CONTINUOUS") || (variableObj.inputType === "angle-magnitude") ? (
                <React.Fragment>
                  <Cell size={3}>
                    <TextField
                      id="text-black-list-y"
                      label={`Excluded List for ${
                        variableObj.inputType === "components" ? "Y" : "angle"
                      }`}
                      placeholder="Multiple values must be comma separated"
                      type="text"
                      helpText="comma separated"
                      onChange={(value) => {
                        variableObj[getsecondInput(variableObj.inputType)] = value;
                        onChange(variableObj);
                      }}
                      value={variableObj[getsecondInput(variableObj.inputType)] || ""}
                    />
                  </Cell>
                </React.Fragment>
              ) : null
              : null}
          </Grid>
      </React.Fragment>
  )
};

const AngleOptions = ({ variableObj, i, props, visible }) => {
  let angleOptions = variableObj ? variableObj.angleOptions : {};
  if (!angleOptions) {
    {
      angleOptions = {};
    }
  }

  const getHelpText = () => {
    return <p className="custom-tooltip-text">{
      AngleDisplayOptions.map((array, index) => {
        return (<p>Option{index + 1}: {array.label}</p>)
      })}
    </p>
  }

  if (visible) {
    return (
      <React.Fragment>
        <Grid>
          <Cell size={4}>
            <SelectField
              helpText="Select a Angle Display Option"
              id={`angle-option-${i}`}
              label="Angle Display Options"
              onChange={(value) => {
                angleOptions = { ...angleOptions, type: value };
                variableObj.angleOptions = angleOptions;
                props.onChange(variableObj);
              }}
              menuItems={[1, 2, 3]}
              value={angleOptions.type}
            />
            <Button
              className="nocqcStyle"
              icon
              tooltipLabel={getHelpText()}
            >
              help
            </Button>
          </Cell>
          <Cell size={4}>
            <TextField
              id={`angle-offset-${i}`}
              label="angle offset from base angle"
              placeholder="Offset Angle"
              type="number"
              helpText="The base angle is with reference to x axis, change offset value to change it"
              onChange={(value) => {
                angleOptions = {
                  ...angleOptions,
                  angleOffset: value ? parseFloat(value): '',
                };
                variableObj.angleOptions = angleOptions;
                props.onChange(variableObj);
              }}
              value={angleOptions.angleOffset}
            />
          </Cell>
          <Cell size={4}>
            <label
              htmlFor={`show-angle-clockwise-${i}`}
              className="vectors-toggle-label"
            >
              {"Angle Direction Clockwise"}
            </label>
            <Toggle
              icons={false}
              width={230}
              id={`show-angle-clockwise-${i}`}
              name="Angle Direction"
              onChange={(event) => {
                angleOptions = {
                  ...angleOptions,
                  clockwise: event.target.checked,
                };
                variableObj.angleOptions = angleOptions;
                props.onChange(variableObj);
              }}
              checked={angleOptions.clockwise}
            />
          </Cell>
        </Grid>
      </React.Fragment>
    );
  } else {
    return null;
  }
};

export default VectorVariableOption;

export const createEmptyVectorAnswerFormula = (index) => {
  return {
    name: "",
    formulaType: "components",
    angleFormula: "",
    formulaColor: "#000000", //getColorsArrayDisPlayOrder(index),
    magFormula: "",
    xFormula: "",
    yFormula: "",
    posX: "0",
    posY: "0",
    showComponents: false,
    xOrigin: "5",
    yOrigin: "5",
    autoOrigin: true,
    evaluate_x: 0, // 0 means true, so by default when vector answer formula is created evaluate x and y is toggled ON
    evaluate_y: 0, // 0 means true
    evaluate_angle: 0,
    evaluate_magnitue: 0,
  };
};

export const VectorQuestionHelp = function (props) {
  return [
    <div className="image-resize-warning RTWrapper" key="help-text-1">
      <p>
        <b>Help :</b> Enter vector variable names inside square bracket '[]'. To
        use latex mode, you must use $[ ]$ eg: What is $[\vec&#123;A&#125;]$ $+$
        $[\vec&#123;B&#125;]$?
      </p>
    </div>,
    <br key="help-text-br"></br>,
  ];
};
